import EnCAlang from './entries/en-US';
import FrCAlang from './entries/fr_FR';

const AppLocale = {
  // English variants — all share the same message bundle
  en:    EnCAlang,
  en_ca: EnCAlang,
  en_us: EnCAlang,
  // French variants — all share the same message bundle
  fr:    FrCAlang,
  fr_ca: FrCAlang,
  fr_us: FrCAlang,
};

// addLocaleData(AppLocale.en_ca.data);
// addLocaleData(AppLocale.fr_ca.data);
// addLocaleData(AppLocale.zh.data);
// addLocaleData(AppLocale.sa.data);
// addLocaleData(AppLocale.it.data);
// addLocaleData(AppLocale.es.data);


export default AppLocale;
export { LocaleGroupProvider, withLocaleGroup, fetchLocaleGroupMessages, useIntlWithLocalGroups } from "./locale_group_provider";
